export default __webpack_public_path__ + "static/media/Zinc.045bebb1.svg";